export function getObjectById(object, id) {
    return object.find(_ => _.id === id)
}

export function isObjectEmpty(object) {
  return Object.entries(object).length === 0
}

export function cleanId(id) {
    return id.replace("_", "")
}

export function createIdString(id) {
    return id.replace(" ", "_").toLowerCase()
}

export const portraitImageUrl = (id, size) => {
  return id === undefined ? '' : builderStorageUrl('portraits', `portrait_${createIdString(id)}_${size}.png`)
}

export const roleImageUrl = (role) => {
    return role === undefined ? '' : builderStorageUrl('roles', `daily_${role.toLowerCase()}.png`)
}

export const roleAlternateImageUrl = (role) => {
  return role === undefined ? '' : builderStorageUrl('roles', `requirement_${role.toLowerCase()}_icon.png`)
}

export const factionImageUrl = (faction) => {
    return faction === undefined ? '' : builderStorageUrl('roles', `requirement_${faction.toLowerCase()}_icon.png`)
}

export const coreImageUrl = (id) => {
    return id === undefined ? '' : builderStorageUrl('core', `${createIdString(id)}_core.png`)
}

export const specialImageUrl = (id) => {
    return id === undefined ? '' : builderStorageUrl('special', `${createIdString(id)}_special.png`)
}

export const talentImageUrl = (index, id) => {
    return id === undefined ? '' : builderStorageUrl('talents', `ref_${createIdString(id)}_${index}.png`)
}

export const extraImageUrl = (image, ext = 'jpg') => {
    return builderStorageUrl('extras', `${image}.${ext}`)
}

const builderStorageUrl = (folder, image) => {
  return `https://firebasestorage.googleapis.com/v0/b/mirrorverse-db.appspot.com/o/${folder}%2F${image}?alt=media`
}

export const colorForRole = (role) => {
    switch(role.toLowerCase()){ 
        case 'melee':
            return 'red'
        case 'tank':
            return 'blue'
        case 'ranged':
            return 'yellow'
        case 'support':
            return 'green'
        default:
            return ''
    }
}

export async function makeGetRequest(url) {
    return makeRequest("GET", url)
}

export async function makePutRequest(url, data) {
    return makeRequest("PUT", url, data)
}

export async function makePostRequest(url, data) {
    return makeRequest("POST", url, data)
}

async function makeRequest(method, url, data = {}) {
    const options = {
      method: method, // *GET, POST, PUT, DELETE, etc.
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/json',//x-www-form-urlencoded',
        'Connection': 'Keep-Alive',
      }
    }
    
    if (method !== 'GET' && method !== 'DELETE') {
      options.body = JSON.stringify(data) // body data type must match "Content-Type" header
    }
    
    const result = await fetch(url, options)
    .then(res => {
      return res.ok ? res.json() : null
    })
    .then((result) => {
      return result
    }).catch((error) => {
      console.log(error);
      return null
    })
  
    return result
  }
